import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	secondsNonfinal: {
		id: 'standups.timer.timer-input.seconds-nonfinal',
		defaultMessage: 'Seconds',
		description: 'The accessibility label name for the field representing seconds in the timer',
	},
	minutesNonfinal: {
		id: 'standups.timer.timer-input.minutes-nonfinal',
		defaultMessage: 'Minutes',
		description: 'The accessibility label name for the field representing minutes in the timer',
	},
});
